import React from "react";

export default function AdvertisingPolicy() {
  const lastUpdated = new Date().toDateString();

  const wrapperStyle = {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "30px 20px",
    fontFamily: "'Poppins', sans-serif",
    lineHeight: "1.7",
    color: "#e0e0e0",
    backgroundColor: "#1a1a2e",
    borderRadius: "12px",
    boxShadow: "0 0 25px rgba(0, 255, 208, 0.1)",
  };

  const h1Style = {
    fontSize: "2.8rem",
    fontWeight: "700",
    marginBottom: "20px",
    color: "#00ffd0",
    textAlign: "center",
    textShadow: "0 0 10px #00ffd0, 0 0 20px #a76fff",
  };

  const h2Style = {
    fontSize: "1.8rem",
    marginTop: "30px",
    marginBottom: "12px",
    color: "#a76fff",
  };

  const pStyle = {
    fontSize: "1rem",
    marginBottom: "12px",
    color: "#ccc",
  };

  const ulStyle = {
    paddingLeft: "1.4em",
    marginBottom: "12px",
  };

  const liStyle = {
    margin: "6px 0",
  };

  const contactStyle = {
    fontWeight: "600",
    color: "#00ffd0",
  };

  const lastUpdatedStyle = {
    marginTop: "30px",
    fontSize: "0.85rem",
    color: "#888",
    textAlign: "right",
  };

  return (
    <div style={wrapperStyle}>
      <h1 style={h1Style}>Advertising Policy</h1>

      <p style={pStyle}>
        This Advertising Policy describes how advertisements are displayed and managed on GameHub,
        accessible through <strong>gamehub.samsoftix.com</strong>. We aim to maintain a safe, transparent, and user-friendly 
        advertising experience for all visitors.
      </p>

      <h2 style={h2Style}>Use of Google AdSense</h2>
      <p style={pStyle}>
        GameHub may use Google AdSense to display contextual or personalized advertisements. We follow
        Google’s publisher policies, including restrictions against prohibited content types, invalid
        click activity, and misleading ad placement.
      </p>

      <h2 style={h2Style}>Ad Placement</h2>
      <p style={pStyle}>We ensure that advertisements do not:</p>
      <ul style={ulStyle}>
        <li style={liStyle}>Interfere with game functionality</li>
        <li style={liStyle}>Block important UI elements</li>
        <li style={liStyle}>Mislead users into accidental clicks</li>
        <li style={liStyle}>Trigger aggressive pop-ups or redirects</li>
      </ul>
      <p style={pStyle}>Ads may appear in non-intrusive areas such as:</p>
      <ul style={ulStyle}>
        <li style={liStyle}>Sidebars</li>
        <li style={liStyle}>Headers or footers</li>
        <li style={liStyle}>Between content sections</li>
        <li style={liStyle}>Loading screens where appropriate</li>
      </ul>

      <h2 style={h2Style}>Personalized Advertising</h2>
      <p style={pStyle}>
        Some ads may be personalized based on your prior web interactions. You may control your ad
        personalization preferences through your Google account settings.
      </p>

      <h2 style={h2Style}>Third-Party Advertisers</h2>
      <p style={pStyle}>
        Advertisements displayed on GameHub may originate from Google or other certified ad networks.
        We are not responsible for the content or claims of external advertisements.
      </p>

      <h2 style={h2Style}>User Interaction With Ads</h2>
      <p style={pStyle}>
        Clicking advertisements is voluntary. We do not encourage or incentivize users to click ads
        artificially, and any form of automated or fraudulent clicking is prohibited.
      </p>

      <h2 style={h2Style}>Prohibited Content</h2>
      <p style={pStyle}>We do not host or monetize ads related to:</p>
      <ul style={ulStyle}>
        <li style={liStyle}>Adult or explicit content</li>
        <li style={liStyle}>Gambling or betting</li>
        <li style={liStyle}>Illegal activities</li>
        <li style={liStyle}>Hate speech or extremist ideology</li>
        <li style={liStyle}>Malware or unsafe software</li>
      </ul>

      <h2 style={h2Style}>Reporting Problematic Ads</h2>
      <p style={pStyle}>
        If you encounter an inappropriate or suspicious advertisement, please contact us immediately at:
      </p>
      <p style={contactStyle}>Email: samsoftix@gmail.com</p>

      <p style={lastUpdatedStyle}>Last updated: {lastUpdated}</p>
    </div>
  );
}
